export enum InfoTypeStringEnum {
  news = 'news',
  newReleases = 'new-releases',
  promotions = 'promotion',
}

export enum InfoTypeEnum {
  news = 1,
  newReleases = 2,
  promotions = 3,
}
